exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-cda3ddcc] {\n  padding: 0px 20px;\n  background-color: #fff;\n}\n.action-detail[data-v-cda3ddcc] {\n  color: #0077fa !important;\n  cursor: pointer !important;\n}\n.action-detail .forbidden[data-v-cda3ddcc] {\n  pointer-events: none;\n  cursor: default;\n  color: #8bc1f3;\n}\n", ""]);

// exports
